export function getReaderCardFocus(data) {
  const readerFocus = [];
  const focus = data.acf.reader_profile_focus_hdfocus;

  if (focus === null) {
    return;
  }

  Object.entries(focus).forEach(([key, value]) => {
    if (value === true) {
      if (key.includes('business')) readerFocus.push('Business');
      if (key.includes('career')) readerFocus.push('Karriere');
      if (key.includes('family')) readerFocus.push('Familie & Kinder');
      if (key.includes('love')) readerFocus.push('Liebe & Partnerschaft');
    }
  });
  return readerFocus;
}
